export function isPack(planName: string) {
  return /pack/gi.test(planName);
}
